import { Select, Skeleton } from 'antd';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDepartments } from '@/common/useDepartments';

const { Option } = Select;

export const HeaderSelect = () => {
  const { departments, selectedDepartmentId, setSelectedDepartmentId, isLoading } =
    useDepartments();
  const [searchParams, setSearchParams] = useSearchParams();

  const sortedDepartments = useMemo(
    () => departments.slice().sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')),
    [departments]
  );

  const handleDepartmentChange = useCallback(
    (departmentId: number) => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set('departmentId', String(departmentId));
      nextParams.delete('orderId');
      setSearchParams(nextParams, { replace: true });
      setSelectedDepartmentId(departmentId);
    },
    [searchParams, setSearchParams, setSelectedDepartmentId]
  );

  return (
    <div>
      {isLoading ? (
        <Skeleton.Button active size="small" style={{ width: 150, height: 24 }} />
      ) : (
        <Select
          showSearch
          optionFilterProp="children"
          value={selectedDepartmentId}
          style={{ width: '150px' }}
          onChange={handleDepartmentChange}
        >
          {sortedDepartments.map((department) => (
            <Option key={department.id} value={department.id}>
              {department.name}
            </Option>
          ))}
        </Select>
      )}
    </div>
  );
};
